import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { getSearchState } from 'data/search'
import { isSidebarCollapsed } from 'data/ui/selectors'

export const PANEL_DEFAULT_WIDTH = 300
export const PANEL_MIN_WIDTH = 300
export const PANEL_MAX_WIDTH = 500
const SIDE_PANEL_WIDTH = 'SIDE_PANEL_WIDTH'

export const getSavedPanelWidth = () =>
  parseInt(localStorage.getItem(SIDE_PANEL_WIDTH), 10) || PANEL_DEFAULT_WIDTH

const setSavedPanelWidth = value =>
  localStorage.setItem(SIDE_PANEL_WIDTH, value)

class ResizablePanel extends Component {
  static defaultProps = {
    onDragEnabled: () => {},
    onDragReleased: () => {},
    onResize: () => {},
  }

  state = {
    onDrag: false,
    dragOption: false,
    mousePosition: 0,
    panelWidth: getSavedPanelWidth(),
    onDragPanelWidth: 0,
    forceStopDraggingOnMouseUp: false,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCollapsed && !this.props.isCollapsed) {
      const panelWidth = getSavedPanelWidth()
      this.setState({ panelWidth }, () => {
        setSavedPanelWidth(panelWidth)
      })
    }
  }

  addMouseMoveListener = () =>
    window.addEventListener('mousemove', this.handleMouseMove)

  removeMouseMoveListener = () =>
    window.removeEventListener('mousemove', this.handleMouseMove)

  handleMouseMove = event => {
    const translateX = event.screenX - this.state.mousePosition
    const onDragPanelWidth = this.state.panelWidth + translateX
    if (
      this.props.navigatingFullTextSearch &&
      onDragPanelWidth < PANEL_DEFAULT_WIDTH
    ) {
      return this.setState(
        { onDragPanelWidth: PANEL_DEFAULT_WIDTH },
        this.disableDrag
      )
    }

    if (onDragPanelWidth > PANEL_MAX_WIDTH) {
      return this.setState({ onDragPanelWidth: PANEL_MAX_WIDTH }, () =>
        this.props.onResize(PANEL_MAX_WIDTH)
      )
    }
    if (onDragPanelWidth < PANEL_MIN_WIDTH) {
      return this.setState({ onDragPanelWidth: PANEL_MIN_WIDTH }, () =>
        this.props.onResize(PANEL_MIN_WIDTH)
      )
    }
    this.setState({ onDragPanelWidth }, () =>
      this.props.onResize(onDragPanelWidth)
    )
  }

  enableDragOption = () => {
    if (this.props.isSearchActive) {
      return
    }
    this.timeoutDragOptionDisplay = setTimeout(
      () => this.setState({ dragOption: true }),
      100
    )
  }

  disableDragOption = () => {
    clearTimeout(this.timeoutDragOptionDisplay)
    this.setState({ dragOption: false })
  }

  enableDrag = event => {
    this.setState(
      {
        onDrag: true,
        mousePosition: event.screenX,
        onDragPanelWidth: this.state.panelWidth,
      },
      () => {
        this.addMouseMoveListener()
        this.props.onDragEnabled()
      }
    )
  }

  disableDrag = event => {
    if (!this.state.onDrag) {
      return
    }
    this.setState(
      {
        onDrag: false,
        panelWidth: this.state.onDragPanelWidth,
      },
      () => {
        setSavedPanelWidth(this.state.onDragPanelWidth)
        this.removeMouseMoveListener()
        this.props.onDragReleased(this.state.onDragPanelWidth)
      }
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.state.onDrag && (
          <div
            onMouseUp={this.disableDrag}
            onMouseLeave={this.disableDrag}
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: -250,
              right: 0,
              zIndex: 3,
              background: 'transparent',
            }}
          />
        )}
        <div
          unselectable="on"
          className={classNames(
            'slite-design-system no-print l-sidepanel',
            this.props.className
          )}
          style={{
            ...this.props.style,
            userSelect: 'none',
            maxWidth: PANEL_MAX_WIDTH,
            width: this.state.onDrag
              ? this.state.onDragPanelWidth
              : this.state.panelWidth,
          }}
        >
          {this.props.children}
          <div
            className="flexbox flexbox-align-center flexbox-justify-center"
            onMouseEnter={this.enableDragOption}
            onMouseLeave={this.disableDragOption}
            onMouseDown={this.enableDrag}
            onMouseUp={this.disableDrag}
            style={{
              position: 'absolute',
              top: 0,
              left: this.state.onDrag
                ? this.state.onDragPanelWidth - 400
                : this.state.panelWidth - 6,
              width: this.state.onDrag ? 800 : 12,
              height: '100vh',
              background: 'transparent',
              cursor: this.state.dragOption ? 'col-resize' : 'default',
              zIndex: 4,
            }}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default connect(state => {
  const searchState = getSearchState(state)
  return {
    navigatingFullTextSearch: searchState.navigatingFullTextSearch,
    isCollapsed: isSidebarCollapsed(state),
    isSearchActive: searchState.isActive,
  }
})(ResizablePanel)
